export default "__VITE_ASSET___dHbIRzC__"